import styled from "styled-components";

import atportLogo from "atport_logo.svg";
import ExceptionButton from "components/ExceptionButton";
import color from "constants/color";

const Wrap = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-width: 100vw;
  background-color: ${color.white};
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  text-align: center;
`;
const Logo = styled.img`
  width: 318px;
`;
const Label = styled.p`
  font-size: 32px;
  font-weight: bold;
`;
const Description = styled.p`
  font-size: 16px;
  color: ${color.text.gray};
  margin-top: -20px;
`;

const InternalError = () => {
  const navigateTop = () => {
    window.location.replace("/");
  };
  return (
    <Wrap>
      <Content>
        <Logo src={atportLogo} alt="at PORT" />
        <Label>500 : Internal Server Error</Label>
        <Description>申し訳ありません、予期せぬエラーが発生しました。</Description>
        <ExceptionButton label="トップページへ" width="160px" type="secondary" onClick={navigateTop} />
      </Content>
    </Wrap>
  );
};

export default InternalError;
